import * as React from "react";
import "./Questions.sass";
import AccordionItem from "./../../../components/AccordionItem";

export default function Questions() {
  const faqs = [
    {
      question: "What's the Total Supply of Frens?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>1,777 Hand-Crafted Comfy First Edition Frens</p>
          <p>Created to Save the Metaverse from the Wage Cage</p>
        </div>
      ),
    },
    {
      question: "How much?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            Our WL system has 5 levels: <br />
            <br /> 1) fren (work to get WL)(you can't mint yet)
            <br />
            <br /> 2) WL: (1 Sol, 1,000 spots) <br />
            3) Pre-sale WL: (0.77 Sol, 600 spots)
            <br /> 4) OG WL: (0.25 Sol, 100 spots)
            <br /> 5) Infinity Club (Free, 77 spots)
          </p>
        </div>
      ),
    },
    {
      question: "When?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>January</p>
        </div>
      ),
    },

    {
      question: " What are the Regiments?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            Kek (The Demiurge) <br />
            Possess the Most Powerful Glorious GIF Powers <br />
            The fashioner of the Metaverse <br /> <br />
            17 Frog Gods <br />
            Leaders of FrenDAO <br />
            Holy protectors of Kek’s will <br />
            Granted Kek’s glorious GIF powers <br /> <br />
            100 Demigods <br />
            Frens with godly powers <br />
            Granted some of Kek’s glorious GIF powers <br /> <br />
            1,660 Frens <br />
            Comfy Frens made in Kek’s image <br />
            Entrusted to lead the charge <br /> <br />
            CyberFrens <br />
            A new class of warriors, created with the frENGINE <br />
            Blessed with Kek's Glorious GIF powers
          </p>
        </div>
      ),
    },

    {
      question: "What's the degENGINE?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            The degENGINE is the primary means by which goods are produced for
            the Frens War Economy. Without the degENGINE the Frenconomy will
            fail as there will be no means of production to stimulate our GDP
            Growth. While not the only mechanism used to sustain the Frenconomy
            it can be viewed as the beating heart. <br /> To run properly it
            requires: <br /> <br />• TENDIES token to operate as the machine’s
            Fuel <br /> • 2 first edition Frens NFTs from any Regiment Operate
            the Machine
          </p>
        </div>
      ),
    },
    {
      question: "What can I get from the degENGINE?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            You can get items to help the Frens fight more effectively. <br />{" "}
            Some of these include:
            <br /> • Mystery Box (90%): Crystals Arc Reactor CyberFren More
            TENDIES <br /> • TENDIES burn (10%):
            <br /> This machine loves TENDIES <br /> Better luck next time Degen
          </p>
        </div>
      ),
    },
    {
      question: "What is the frENGINE?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            The frENGINE is a beautiful machine that allow the user to produce a
            CyberFren 100% of the time. <br /> <br /> To run properly it
            requires: <br />
            • Crystals <br />
            • Arc Reactor <br />• 2 first edition Fren NFTs from any Regiment to
            Operate the Machine
          </p>
        </div>
      ),
    },
    {
      question: "How do Battle Rewards work?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            At the beginning of each battle Frens are invited to stake their NFT
            and pledge loyalty to the cause. This will earn them guaranteed
            TENDIES as rewards. War Heroes will be declared by the FrenDAO at
            the completion of each battle after verification and will receive
            various prizes. At the completion of each battle the game restarts
            and the FrenDAO reconvenes to discuss the next mission.
          </p>
        </div>
      ),
    },
    {
      question: "What Mechanisms Stabilize the Frenconomy?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            The Frenconomy is first stabilized through a set Vesting Schedule.
            Meaning, $TENDIES will have a set schedule by which they are
            dispersed. Additionally, there will be two primary ways to acquire
            $TENDIES using your NFT. One is through the processes of Staking by
            pledging loyalty to a mission and the second being earning top rank
            for a battle and becoming a “War Hero”. This steady disbursement
            schedule verified by the FrenDAO (acting as our Central Bank) will
            provide sustainability to our War Economy. <br /> <br />
            The Frenconomy is stabilized by the same mechanisms used by world
            economies today. In the past US Dollars were known as “Silver
            Certificates”. Meaning they could literally be exchanged at the bank
            for a set amount of silver. In 1964 this system was declared
            antiquated and phased out. Today, the US dollar is a fiat currency
            backed by a Central Bank. Therefore, it is backed by Belief, GDP
            Growth, ability to collect Tax Revenue, and FORCE. <br /> <br />
            Belief – Frens will be required to have a true belief in the core
            values of OnlyFrens. Fighting against the Wage Cage and societal
            injustices in their many hidden forms. <br /> <br />
            GDP Growth – World economies are primarily measured by their ability
            GROW. This means we must allow for a practical utility for why
            anyone would want to hold $TENDIES. The Frenconomy will employ the
            following distinct strategies for growth. <br /> <br />
            1) The Dream Machine <br />
            a. degENGINE <br />
            b. frENGINE <br />
            2) Allow for mints only available for purchase through use of our
            Native $TENDIES token <br />
            3) $TENDIES Auctions <br />
            4) Fren Casino <br />
            5) Allow for early access to Mints and WL opportunities based on
            $TENDIES holdings, Mint for LESS <br />
            6) Allow more members to join our ranks when demand outweighs
            supply. This process will have to be verified by the FrenDAO. <br />{" "}
            <br />
            “Tax Revenue” – This will be the Royalties collected on the sale of
            all OnlyFrens NFTs of all collections, Dream Machine Maintenance,
            Fren Casino house edge
            <br /> <br />
            FORCE – A “Giddy Multitude” of Frogs equipped with the dankest of
            Memes shall serve as all the force required to stabilize our War
            Economy. We believe that our numerous glorious victories will put
            any challengers at bay. The Frens’ ability to Meme more effectively
            than anyone will inspire others to join our ranks. Those who go
            against our virtuous causes will be challenged by a well-equipped,
            organized, and incentivized army guided by unbreakable morale as a
            result of their clear vision and deep-rooted belief in the causes
            they fight for. While it is nice token is earned for our battle,
            token is not our main motivating factor.
          </p>
        </div>
      ),
    },
    {
      question: "What's the Wage Cage? ",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            The Wage Cage is a complex topic currently manifested in two known
            forms at this time. A literal physical representation and a
            metaphorical form. The former being the literal Wage Cage Patented
            by the nefarious Bezos and Amazon Corporation under the guise of a
            “Human Transport Device” Amazon Technologies, Inc. (Seattle, WA, US)
            United States Patent 9280157. The latter being, the McJob we are all
            forced to attend on a regular basis against our will (Wage Slavery).
            Amazon’s patent was simply confirmation that those in charge view us
            simply as “Wagies” to be locked in our “Cagies”. Current societal
            structure proves many monopolistic corporations have no issue with
            putting employees in unreasonable work conditions while
            incentivizing them from unionizing in any way possible. This concept
            often leads to deep thought and philosophical debate with advocates
            of the “Wage Cage” often dubbing it a misunderstanding and rushing
            to the defense of the Innocent Billionaire Bezos who “never ever
            conspired against his employees ever”… Our Team finds these
            practices troubling to say the least!{" "}
          </p>
        </div>
      ),
    },
    {
      question: "Can anyone mint a Fren?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            Initially, only our WL will be able to mint. There is a Rumor that
            Zuck is planning to unleash his Robots on our Mint. We are taking
            every precaution possible to protect our Mint from Zuck and his army
            of robots!
          </p>
        </div>
      ),
    },
    {
      question: "Why should I Mint a Fren?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            To secure the future of the Metaverse itself and defend ALL from the
            nefarious Wage Cage! <br />
            Owning a Fren will allow you to participate in battle missions! This
            will be the very first form of incentivized shilling spilling out
            IRL to create the first NFT War Economy, known as the Frenconomy.{" "}
            <br />
            Why is this worth going to War over? <br /> <br />
            If Bezos and Zuck trick us once again into selling our Secret
            Internet Monies they will take over the Metaverse for good this
            time. <br />
            A system of permanent WageCucking will surely be instituted into
            their “New and Improved” Metaverse entrapping us all in a permanent
            virtual Wage Cage from which we will never escape. <br />
            Bezos and Zuck are said by some to participate in practices such as
            predatory pricing and anti-competitive practices. <br />
            Now is the time to use Uncle Elon’s beautiful technology!
            Specifically created to give Divine Powers to the Frens. <br />
            We must save the Metaverse from the Wage Cage!
          </p>
        </div>
      ),
    },
    {
      question: "What causes can the Frens Fight for?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            The Frens can fight ANY injustice so long as the FrenDAO approves
            the community vote! <br />
            Every Battle will be marked by an OFFICIAL Declaration which will
            include a List of Demands in the Form of a Change.org petition.{" "}
            <br />
            OnlyFrens will be the first NFT project with real world implications
            backed by tokenized incentives. We will shape a brighter future for
            ALL!
          </p>
        </div>
      ),
    },
    {
      question: "So what game are the frens actually playing?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            1. Kek announces a call to arms and a declaration to fight a
            societal injustice based on a community vote <br />
            2. The FrenDAO establishes a list of demands and a formal
            declaration detailing the reason for battle Petitioned to Change.org{" "}
            <br />
            3. Frens pledge their loyalty through staking <br />
            4. Frens are invited to take the battle to Twitter <br />
            5. Frens spread the word of Kek and the evils of the Wage Cage (or
            relevant battle) <br />
            6. At the end of each battle a select group of the most active Frens
            from each regiment are honored as War Heroes and Verified by the
            FrenDAO <br />
            7. Frens loyal enough to stake are Rewarded <br />
            8. Upon seeing our many glorious Twitter victories and Media
            coverage detailing our unbreakable will, an unending cycle of Normie
            FOMO ensues ensuring sustainable growth
          </p>
        </div>
      ),
    },
    {
      question:
        "What mechanisms stabilize the Community and allow the frens to reach consensus?",
      answer: (
        <div className="feed-rte w-richtext">
          <p>
            If we are fighting against social injustices surely there must be a
            system set in place offering stability and consensus among the
            frens. Without such a mechanism, our community would devolve into a
            pseudo DAO (many such cases) where we are left talking about surface
            level personal achievement humble brags as opposed to anything
            actually meaningful. Such a structure is more reminiscent of a "book
            club" than a DAO. The result of this is typically a community
            turning into a meetup with nothing to do, but talk about nonsense as
            it slowly burns out and the spark is lost. If we are indeed an
            organization there must be structure and we must actually be doing
            something! Our mission is higher than any one member and we must
            always hold these beliefs as core values to our cause! This requires
            multiple things: <br /> <br />
            Including but not limited to: <br /> <br />
            1. Clear Purpose <br />
            2. Voting Rights <br />
            2. A Hierarchical Structure <br />
            3. Bylaws <br />
            4. Meeting Minutes (yeah...seriously if you want to get paid that
            is) <br />
            4. A system of Checks and Balances <br /> <br />
            Through this a system will be made where all frens are created
            frenly, that they are endowed by their Creator, Kek, with certain
            inalienable Rights, that among these are Memes, Liberty and the
            pursuit of Tendies. <br /> <br />A new covenant has been gifted to
            the frens from the divine. We must hold these values as core tenets
            to be as frenly as possible, but strike with dank and spicy memes to
            those who oppose us in our frenly missions.
          </p>
        </div>
      ),
    },
  ];

  return (
    <section className="section faq">
      <div className="padding-wrapper mt-4 mb-4 ">
        <div className="container feed">
          <div className="feed-collection w-dyn-list">
            <div role="list" className="feed-list w-dyn-items">
              {faqs.map((item) => {
                return (
                  <AccordionItem
                    key={item.question}
                    question={item.question}
                    answer={item.answer}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div id="feed" className="feed-marker"></div>
    </section>
  );
}
